/* global __SERVER__ */
import React, { PropTypes } from 'react';

import { primary as buttonPrimary } from '../Button/styles.module.css';
import { loadMore } from './styles.module.css';

const LoadMore = ({
  count,
  onClick,
  total,
}) => (
  <div>
    {!__SERVER__ && (count < total) &&
      <div className={loadMore}>
        <button className={buttonPrimary} onClick={onClick}>
          Load More
        </button>
      </div>}
  </div>
);

export default LoadMore;

LoadMore.propTypes = {
  /**
   * Number of events loaded in current state event list.
   */
  count: PropTypes.number.isRequired,
  /**
   * Function to invoke upon clicking 'Load More'.
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Number of events for current list (and query) found on the server.
   */
  total: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./app/src/components/LoadMore/component.jsx